import { Loader } from '@/components/ui'

export const OpeningPage = () => (
  <div className="flex size-full items-center justify-center text-neutral-400">
    <Loader size="md" />
  </div>
)
